import React from "react";
import { useFormContext } from "react-hook-form";
import { DateControl } from "@tiny/components";
import { useStyles } from "../Value.styles";

interface DateValueProps {
  prefixName: string;
  type: "number" | "number[]";
  disabled?: boolean;
}

function DateValue(props: DateValueProps) {
  const { prefixName, type, disabled } = props;

  const classes = useStyles();

  const { trigger } = useFormContext();

  const name =
    type === "number[]"
      ? `${prefixName}.value.value[0]`
      : `${prefixName}.value.value`;

  React.useEffect(() => {
    trigger([name]);
  }, [trigger, name]);

  return (
    <div className={classes.root}>
      <DateControl
        name={name}
        aria-label="Condition value"
        showHelperTextMargin
        required
        disabled={disabled}
        placeholder="Date"
      />
    </div>
  );
}

export default DateValue;
